import { PublicClientApplication } from "@azure/msal-browser";

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: process.env.VUE_APP_AAD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.VUE_APP_AAD_TENANT_ID}`,
    redirectUri: process.env.VUE_APP_AAD_REDIRECT_URI || window.location.origin
  },
  cache: { cacheLocation: "sessionStorage" }
});

// Devuelve el ID token de Microsoft tras el login interactivo (popup).
export async function signInWithMicrosoft() {
  const result = await msalInstance.loginPopup({
    scopes: ["openid", "profile", "email"]
  });
  return result.idToken;
}
